export type HomeSectionId = 'used' | 'repairs';

/**
 * Which section of the landing goes first under the hero. PhoneTec has not chosen yet
 * (OD-018): swapping the two ids is the whole change.
 */
export const homeSectionOrder: HomeSectionId[] = ['used', 'repairs'];
